export default {
  SET_IS_NEW_PROFILE: 'SET_IS_NEW_PROFILE',
  SET_CAME_FROM: 'SET_CAME_FROM',
  SET_URL_PARAMETERS: 'SET_URL_PARAMETERS',
  SET_LANG: 'SET_LANG',
  SET_LAST_OPENED_URL: 'SET_LAST_OPENED_URL',
};
